import React from "react";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import RecentNews from '../components/Recent-News'

const LatestBlogPost = () => {
    return (
        <Container className="our-blog-post">
            <Row>
                <Col md="8">
                    <h2>Latest Post</h2>
                    <Stack className="our-blog-post-column our-blog-post-left-column">
                        <Stack className="our-blog-post-list flex-row">
                            <Stack className="blog-post-img">
                                <Image src="/images/blog-post-1.jpg" />
                            </Stack>
                            <Stack className="our-blog-post-list-content">
                                <span>October 20, 2023</span>
                                <label>
                                    The Role of AI In Blockchain & Crypto Investments 
                                </label>
                                <p>
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                                <Link to="">
                                    Learn More 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M8.11667 5.19767H0V4.04264H8.11667L4.38333 0.808527L5.33333 0L10.6667 4.62015L5.33333 9.24031L4.38333 8.43178L8.11667 5.19767Z" fill="#FF4103"></path></svg>
                                </Link>
                            </Stack>
                        </Stack>
                        <Stack className="our-blog-post-list flex-row">
                            <Stack className="blog-post-img">
                                <Image src="/images/blog-post-2.jpg" />
                            </Stack>
                            <Stack className="our-blog-post-list-content">
                                <span>October 20, 2023</span>
                                <label>
                                    The Role of AI In Blockchain & Crypto Investments 
                                </label>
                                <p>
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                                <Link to="">
                                    Learn More
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M8.11667 5.19767H0V4.04264H8.11667L4.38333 0.808527L5.33333 0L10.6667 4.62015L5.33333 9.24031L4.38333 8.43178L8.11667 5.19767Z" fill="#FF4103"></path></svg> 
                                </Link>
                            </Stack>
                        </Stack>
                        <Stack className="our-blog-post-list flex-row">
                            <Stack className="blog-post-img">
                                <Image src="/images/blog-post-3.jpg" />
                            </Stack>
                            <Stack className="our-blog-post-list-content">
                                <span>October 20, 2023</span>
                                <label>
                                    The Role of AI In Blockchain & Crypto Investments 
                                </label>
                                <p>
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                                <Link to="">
                                    Learn More
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M8.11667 5.19767H0V4.04264H8.11667L4.38333 0.808527L5.33333 0L10.6667 4.62015L5.33333 9.24031L4.38333 8.43178L8.11667 5.19767Z" fill="#FF4103"></path></svg>
                                </Link>
                            </Stack>
                        </Stack>
                        <Stack className="our-blog-post-list flex-row">
                            <Stack className="blog-post-img">
                                <Image src="/images/blog-post-4.jpg" />
                            </Stack>
                            <Stack className="our-blog-post-list-content">
                                <span>October 20, 2023</span>
                                <label>
                                    The Role of AI In Blockchain & Crypto Investments 
                                </label>
                                <p>
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                                <Link to="">
                                    Learn More 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M8.11667 5.19767H0V4.04264H8.11667L4.38333 0.808527L5.33333 0L10.6667 4.62015L5.33333 9.24031L4.38333 8.43178L8.11667 5.19767Z" fill="#FF4103"></path></svg>
                                </Link>
                            </Stack>
                        </Stack>
                    </Stack>
                </Col>
                <RecentNews />
            </Row>
        </Container>
    )
}

export default LatestBlogPost;